const SUPER_ORG_METADATA_KEY = 'ALL_ACCESS'
const SUPER_ORG_METADATA_VALUE = 'ADMIN'

function normalizeSuperOrgValue(value) {
  if (value === null || value === undefined) {
    return ''
  }

  return String(value).trim().toUpperCase()
}

/**
 * Checks if the given organization object has super organization access.
 * Supports both the legacy env-configured org ID and the metadata key used by backend auth.
 * @param {Object} organization - Organization object from Clerk's useOrganization()
 * @returns {boolean} - True if the org is super org
 */
export function useIsSuperOrg(organization) {
  if (!organization) {
    return false
  }

  const hasLegacyIdMatch = organization.id === process.env.NEXT_PUBLIC_CLERK_SUPERUSER
  if (hasLegacyIdMatch) {
    return true
  }

  const metadataValue = organization?.publicMetadata?.[SUPER_ORG_METADATA_KEY]
  return normalizeSuperOrgValue(metadataValue) === SUPER_ORG_METADATA_VALUE
}

/**
 * Checks if the given organization ID matches the legacy super organization env var.
 * For metadata-based checks, use useIsSuperOrg with an organization object.
 * @param {string} orgId - The organization ID to check
 * @returns {boolean} - True if the organization ID matches legacy super org ID
 */
export function isSuperOrg(orgId) {
  return orgId === process.env.NEXT_PUBLIC_CLERK_SUPERUSER
}
